import { useRecordContext } from 'react-admin';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import RelationIcon from '@mui/icons-material/Shortcut';
import { styled } from '@mui/material/styles';

const StyledButton = styled(Button)({
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    '&:hover, &:active, &:focus': {
        color: 'inherit',
        textDecoration: 'none',
    },
});

export const RelationLink = props => {
    const record = useRecordContext();

    let to = {};
    if (props.filter) {
        let filter = {};
        if ('_in' === props.filter.slice(-3)) {
            filter[props.filter] = [record.id];
        } else {
            filter[props.filter] = record.id;
        }
        to['search'] = `filter=${JSON.stringify(filter)}`;
    }

    let pathname = `/${props.resource}`;
    if (props.id) {
        pathname += `/${props.id}`;
        if (props.action) {
            pathname += `/${props.action}`;
        }
    }
    to['pathname'] = pathname;

    return (
        <StyledButton
            color='primary'
            startIcon={props.startIcon ? props.startIcon : <RelationIcon />}
            endIcon={props.endIcon || null}
            className={props.endIcon ? 'end-icon' : ''}
            sx={props.sx}
            component={Link}
            size='small'
            to={to}
        >
            {props.label}
        </StyledButton>
    );
};

export const RelationShowLink = ({ resource, id, label }) => {
    if (!id) return null;

    return <RelationLink resource={resource} id={id} label={label} action='show' />;
};
